// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldContainerRegistration.js"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { REPORT_PART_MODE } from 'logic/data/Izenda.ReportBodyConstants';
import { LABEL_TEXT } from 'logic/data/Izenda.ReportPartChartConstants';
import localizer from 'share/localization/Izenda.Localizer';
import containerFactories from 'share/factories/Izenda.ReportPartFieldContainerFactories';

// Field container components
import ReportPartTitle from './Izenda.ReportPartTitle';
import ChartYAxisMetricsContainer from './Izenda.ChartYAxisMetricsContainer';
import GaugeYAxisMetricsContainer from './Izenda.GaugeYAxisMetricsContainer';
import TotalLabel from './Izenda.TotalLabelContainer';
import StaticLabel from './Izenda.StaticLabelContainer';

const createTitle = key => ({
  key: key,
  mode: REPORT_PART_MODE.CONFIG,
  component: ReportPartTitle
});

const createXAxis = (key: string, { axisName, axisCustomName, maximumField }) =>
  createContainer(key, {
    dataKey: 'labels',
    label: axisCustomName
      ? axisCustomName
      : String.format(localizer.getText('REPORTDESIGNER_LABEL_X_AXIS_NAME'), axisName),
    maximumField
  });

const createYAxis = (key: string, { axisName, axisCustomName, maximumField }) =>
  createContainer(key, {
    dataKey: 'values',
    label: axisCustomName
      ? axisCustomName
      : String.format(localizer.getText('REPORTDESIGNER_LABEL_Y_AXIS_NAME'), axisName),
    maximumField
  });

const createChartYAxisMetrics = (key: string) => ({
  key: key,
  label: localizer.getText('REPORTDESIGNER_LABEL_Y_AXIS_VALUES'),
  component: ChartYAxisMetricsContainer
});

const createGaugeYAxisMetrics = (key: string) => ({
  key: key,
  label: localizer.getText('REPORTDESIGNER_LABEL_Y_AXIS_VALUES'),
  component: GaugeYAxisMetricsContainer
});

const createValuesLabels = (key: string, { maximumField }) =>
  createContainer(key, {
    dataKey: 'valuesLabels',
    label: LABEL_TEXT.valueLabel,
    maximumField
  });

const createBubbleSize = (key: string, { maximumField }) =>
  createContainer(key, {
    dataKey: 'bubbleSize',
    label: LABEL_TEXT.bubble,
    maximumField
  });

const createSeparators = (key: string, { maximumField }) =>
  createContainer(key, {
    dataKey: 'separators',
    label: localizer.getText('REPORTDESIGNER_LABEL_SEPARATORS'),
    maximumField
  });

const createTotalLabel = (key: string, containerSchema) => ({
  key: key,
  label: localizer.getText('REPORTDESIGNER_LABEL_TOTAL_LABEL'),
  component: TotalLabel
});

const createStaticLabel = (key: string, { containerKey, label }) => ({
  key: containerKey,
  label: label,
  component: StaticLabel
});

const createContainer = (key: string, { containerKey, label, dataKey, height, maximumField, isHorizontal }) => ({
  key: containerKey || key,
  label,
  dataKey,
  height,
  maximumField,
  isHorizontal
});

(() => {
  containerFactories.register('chart_title', createTitle);
  containerFactories.register('chart_xaxis', createXAxis);
  containerFactories.register('chart_yaxis', createYAxis);
  containerFactories.register('chart_yaxisMetrics', createChartYAxisMetrics);
  containerFactories.register('gauge_yaxisMetrics', createGaugeYAxisMetrics);
  containerFactories.register('chart_valuesLabels', createValuesLabels);
  containerFactories.register('chart_bubbleSize', createBubbleSize);
  containerFactories.register('chart_separators', createSeparators);
  containerFactories.register('chart_totalLabel', createTotalLabel);
  containerFactories.register('staticLabel', createStaticLabel);
  containerFactories.register('container', createContainer);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.FieldContainerRegistration.js